import { Button, makeStyles } from "@material-ui/core";
import React from "react";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import { BASE_URL, extractId, sendData } from "../../../../Models/Fetcher";
import { popupState, refreshTables, toastState } from "../../../../Store/atoms";
import { blurRoot, unBlurRoot } from "../../../../Utilities/DOMFunctions";
import TextValueInput from "../../TextValueInput";

import "./../popup.css";
import "./styles.css";

const useStyles = makeStyles({
  controlButtons: {
    margin: "0 1rem",
  },
});

export default () => {
  const location = useLocation();
  const setPopup = useSetRecoilState(popupState);
  const classes = useStyles();
  const setToast = useSetRecoilState(toastState);
  const tableId = extractId(location.pathname);
  const { handleSubmit, control } = useForm();

  blurRoot();

  const duplicateTable = async (data: any) => {
    const url = BASE_URL + "codetables";
    const response = await sendData(url, "POST", {
      tableId: tableId,
      tableName: data.name,
      userId: localStorage.getItem("userId"),
      description: data.description,
    });

    if (response.status === 200) {
      setToast({
        open: true,
        message: response.data.message,
        severity: "success",
      });
    } else {
      setToast({
        open: true,
        message: response.data.message,
        severity: "error",
      });
    }

    handleClose();
  };

  const handleClose = () => {
    unBlurRoot();
    setPopup(null);
  };

  return (
    <div className="general-popup popup--duplicate-table">
      <div className="popup-name">Create new table</div>
      <form onSubmit={handleSubmit(duplicateTable)} className="duplicate-form">
        <div className="input-container">
          <TextValueInput
            name="name"
            control={control}
            label="Table name"
            defaultValue=""
            errorMsg="Name required"
            required={true}
          />
        </div>
        <div className="input-container">
          <TextValueInput
            name="description"
            control={control}
            label="Table description"
            defaultValue=""
            errorMsg="Description required"
            required={true}
          />
        </div>

        <div className="button-group">
          <Button
            className={classes.controlButtons}
            variant="outlined"
            onClick={handleClose}
            color="primary"
          >
            Cancel
          </Button>
          <Button
            className={classes.controlButtons}
            type="submit"
            variant="contained"
            color="primary"
          >
            Confirm
          </Button>
        </div>
      </form>
    </div>
  );
};
